import './App.css';
import Nav from './components/nav/nav';
import Footer from './components/footer/footer';
import { BrowserRouter } from 'react-router-dom';
import NavWrapper from './components/navWrapper/navWrapper';

function App() {
  return (
    <BrowserRouter>
      <NavWrapper>
          <Nav />
          <Footer />
      </NavWrapper>
    </BrowserRouter>
  );
}

export default App;
